import React from 'react';

import { Flex } from '@chakra-ui/react';
import { useTheme } from '@emotion/react';
import { ICellRendererParams } from 'ag-grid-community';

import { roundOffToPlaces } from 'constants/helper';

import { ProgressBar } from 'uiToolkitV1/ProgressBar';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { Row } from '../MyCompetencies/types/myCompetencies';

export const CFProgressBar = ({ value }: ICellRendererParams<Row, Row['progress']['value']>) => {
  const theme = useTheme();

  return (
    <Flex w="280px" flexDir="column">
      <Flex alignItems="center">
        {/* @ts-expect-error - expects more params */}
        <ProgressBar
          size="large"
          value={roundOffToPlaces(value.displayScore, 2)}
          max={value.maxScore}
          text={value.label}
          color="#DBF2D3"
          textColor="#1A5724"
        />
        <TextBodyMedium ml={2} bold w="80px">
          {value.displayScore}
        </TextBodyMedium>
      </Flex>
    </Flex>
  );
};
